import { useTranslation } from "react-i18next";
import type { CorpusSummary } from "../../../api/content/corporaApi";
import FieldGroup from "../../../ui/forms/FieldGroup";
import OptionLabel from "../../../ui/forms/OptionLabel";

interface CorpusChoiceProps {
  corpora: readonly CorpusSummary[];
  /** Corpora the user unticked; none unticked searches all of the project's corpora. */
  excluded: ReadonlySet<string>;
  onExcludedChange: (excluded: ReadonlySet<string>) => void;
}

/** The corpora a search covers (F20): all are ticked, and the user unticks what to leave out. */
export default function CorpusChoice({ corpora, excluded, onExcludedChange }: CorpusChoiceProps) {
  const { t } = useTranslation();
  const toggle = (corpusId: string, ticked: boolean) => {
    const next = new Set(excluded);
    if (ticked) next.delete(corpusId);
    else next.add(corpusId);
    onExcludedChange(next);
  };
  return (
    <FieldGroup legend={t("search.corpora.legend")} hint={excluded.size === 0 ? t("search.corpora.all") : undefined}>
      <div className="flex flex-wrap gap-x-4 gap-y-1">
        {corpora.map((corpus) => (
        <OptionLabel key={corpus.corpusId}>
          <input type="checkbox" checked={!excluded.has(corpus.corpusId)} onChange={(event) => { toggle(corpus.corpusId, event.target.checked); }} />
          {corpus.name}
        </OptionLabel>
      ))}
      </div>
    </FieldGroup>
  );
}
